import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton QueryClient für die gesamte Dashboard-App.
 * Stale-Time von 5 Minuten, GC nach 10 Minuten.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
